import LoginPage from './Auth/LoginPage';
import DashboardPage from './HomeDashboard/HomeDashboardPage';
import VehiclesPage from './Vehicle/VehiclesPage';
import VehiclesManagementPage from './Vehicle/VehiclesManagementPage';
import FleetsPage from './Fleet/FleetsPage';
import DriversPage from './Driver/DriversPage';
import DriversDashboardPage from './DriversDashboardPage/DriversDashboardPage';

export const ROOT_PATHS = { public: '/login', protected: '/' };

export const ROUTES = [
  {
    path: '/login',
    title: 'Entrar',
    exact: true,
    component: LoginPage,
    publicOnly: true,
  },
  {
    path: '/',
    title: 'Dashboard',
    breadcrumb: 'Home',
    breadcrumb_link: true,
    exact: true,
    component: DashboardPage,
    protectedOnly: true,
  },
  {
    path: '/vehicles',
    title: 'Veículos',
    breadcrumb: 'Veículos',
    breadcrumb_link: true,
    exact: true,
    component: VehiclesPage,
    protectedOnly: true,
  },
  {
    path: '/vehicles/dashboard',
    title: 'Dashboard de Veículos',
    breadcrumb: 'Dashboard',
    breadcrumb_link: true,
    exact: true,
    component: DashboardPage,
    protectedOnly: true,
  },
  {
    path: '/drivers',
    title: 'Motoristas',
    breadcrumb: 'Motoristas',
    breadcrumb_link: true,
    exact: true,
    component: DriversPage,
    protectedOnly: true,
  },
  {
    path: '/drivers/dashboard',
    title: 'Dashboard',
    breadcrumb: 'Dashboard',
    breadcrumb_link: true,
    exact: true,
    component: DriversDashboardPage,
    protectedOnly: true,
  },
  {
    path: '/fleets',
    title: 'Frotas',
    breadcrumb: 'Frotas',
    breadcrumb_link: true,
    exact: true,
    component: FleetsPage,
    protectedOnly: true,
  },
  {
    path: '/management/vehicles',
    title: 'Veículos',
    breadcrumb: 'Veículos',
    breadcrumb_link: true,
    exact: true,
    component: VehiclesManagementPage,
    protectedOnly: true,
  },
];

export default ROUTES;



// WEBPACK FOOTER //
// ./src/routes.js